import { ReactNode, useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { cn } from "../../utils/cn";

export interface FadeInLoadContentTransitionProps {
  className?: string;
  children: ReactNode;
}

/**
 * Attach
 */
const FadeInLoadContentTransitionRoot = ({
  children,
  className,
}: FadeInLoadContentTransitionProps) => {
  const [entered, setEntered] = useState(false);
  useEffect(() => {
    setEntered(true);
    return () => {
      setEntered(false);
    };
  }, []);
  return (
    <Transition
      as="div"
      className={cn(className)}
      show={entered}
      enter="transform transition duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
    >
      {children}
    </Transition>
  );
};

export const FadeInLoadContentTransition = Object.assign(
  FadeInLoadContentTransitionRoot,
  {},
);
